export const CorporateCrest = ({ className = 'w-10 h-12', cracks = 0 }) => (
  <svg viewBox="0 0 96 112" fill="none" className={className} aria-hidden="true">
    <path d="M48 6 L86 18 V52 C86 78 70 96 48 106 C26 96 10 78 10 52 V18 Z" stroke="#C59B27" strokeWidth="2.5" />
    <path d="M48 14 L78 23.5 V52 C78 72.5 65 87.5 48 96.5 C31 87.5 18 72.5 18 52 V23.5 Z" fill="#0F172A" />
    {/* guiding star */}
    <path d="M48 25 L50.2 33 L58 35.2 L50.2 37.4 L48 45.5 L45.8 37.4 L38 35.2 L45.8 33 Z" fill="#C59B27" />
    {/* the lion, couchant and at peace */}
    <g>
      <ellipse cx="47" cy="63" rx="12" ry="5.6" fill="#C59B27" />
      <circle cx="56" cy="60.5" r="4.6" fill="#C59B27" />
      <rect x="38" y="64" width="9" height="3.6" rx="1.8" fill="#C59B27" />
      <path d="M58 60 q6 -2.5 7 -9" stroke="#C59B27" strokeWidth="2" strokeLinecap="round" />
      <circle cx="65.5" cy="50.5" r="2.1" fill="#C59B27" />
      <circle cx="33" cy="53" r="7.6" fill="#C59B27" />
      <circle cx="33" cy="53" r="4.3" fill="#0F172A" stroke="#C59B27" strokeWidth="0.8" />
      <circle cx="30.6" cy="55.4" r="2.2" fill="#C59B27" />
      <circle cx="36.4" cy="47.6" r="1.7" fill="#C59B27" />
      <circle cx="31.6" cy="51.6" r="0.7" fill="#C59B27" />
    </g>
    {/* the lamb, lying beside him */}
    <g>
      <circle cx="61" cy="63.5" r="3.2" fill="#EDE3CB" />
      <circle cx="64.8" cy="61.8" r="3.4" fill="#EDE3CB" />
      <circle cx="68.6" cy="62.6" r="3.3" fill="#EDE3CB" />
      <circle cx="66" cy="65.4" r="3.1" fill="#EDE3CB" />
      <circle cx="62.8" cy="65.2" r="2.9" fill="#EDE3CB" />
      <rect x="61.5" y="67" width="4" height="1.8" rx="0.9" fill="#EDE3CB" />
      <rect x="67.5" y="67.2" width="4" height="1.8" rx="0.9" fill="#EDE3CB" />
      <circle cx="73" cy="58.6" r="3.1" fill="#EDE3CB" />
      <ellipse cx="71.4" cy="55.4" rx="1.6" ry="0.9" fill="#EDE3CB" transform="rotate(-24 71.4 55.4)" />
      <circle cx="74" cy="58" r="0.6" fill="#0F172A" />
    </g>
    {/* laurel */}
    <path d="M24 30 C19 42 19 58 25 72" stroke="#C59B27" strokeWidth="1.4" strokeLinecap="round" strokeDasharray="1.5 5" />
    <path d="M73 32 C77 42 77 56 72 68" stroke="#C59B27" strokeWidth="1.4" strokeLinecap="round" strokeDasharray="1.5 5" />
    {/* ritual fractures */}
    {cracks > 0 && (
      <g stroke="#EFE0B8" strokeWidth="0.7" fill="none" opacity="0.85" strokeLinecap="round">
        <path d="M30 27 l6 9 -4 8 5 6" />
        {cracks > 1 && <path d="M62 29 l-6 8 5 7 -4 9" />}
        {cracks > 2 && (
          <>
            <path d="M48 56 l-4 10 5 7 -3 10" />
            <path d="M21 50 l7 6 M75 47 l-7 7" />
          </>
        )}
      </g>
    )}
  </svg>
);

export const TwistedCrest = ({ className = 'w-10 h-12' }) => (
  <svg viewBox="0 0 96 112" fill="none" className={className} aria-hidden="true">
    {/* ouroboros ring */}
    <circle cx="48" cy="54" r="42" stroke="#8B0000" strokeWidth="3" />
    <circle cx="48" cy="54" r="42" stroke="#DC2626" strokeWidth="0.8" strokeDasharray="2 7" opacity="0.8" />
    <path d="M48 9 l7 9 -7 -2.5 -7 2.5 Z" fill="#DC2626" />
    {/* inverted shield */}
    <path d="M48 102 L14 70 V34 L48 24 L82 34 V70 Z" fill="#08070B" stroke="#D4AF37" strokeWidth="1.5" />
    {/* the lion, roused and ravenous */}
    <g>
      <ellipse cx="46" cy="64" rx="12" ry="5.6" fill="#2A0808" stroke="#DC2626" strokeWidth="0.9" />
      <path d="M58 62 q7 -3 8.5 -11" stroke="#DC2626" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M66.5 51 l3 -3.5 M66.5 51 l4 0.5" stroke="#DC2626" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M33 43.5 L35.6 47.8 L40.2 46.4 L39.2 51 L43.6 53.4 L39.2 55.6 L40.4 60.4 L35.6 59 L33.4 63.6 L31.2 59 L26.4 60.4 L27.6 55.6 L23.2 53.4 L27.6 51 L26.6 46.4 L31.2 47.8 Z" fill="#2A0808" stroke="#DC2626" strokeWidth="0.9" strokeLinejoin="round" />
      <circle cx="33.4" cy="53.4" r="4" fill="#12040A" stroke="#DC2626" strokeWidth="0.6" />
      <circle cx="31.2" cy="51.8" r="2" fill="#DC2626" opacity="0.35" />
      <circle cx="31.2" cy="51.8" r="1" fill="#DC2626" />
      <path d="M29.4 55.4 q-3.5 1.5 -4.5 4.5" stroke="#DC2626" strokeWidth="1" fill="none" />
      <path d="M28.6 55.8 l1.8 0.4 l-1.2 2.2 Z" fill="#EDE3CB" />
      <path d="M25.8 57.4 l1.6 0.6 l-1.4 2 Z" fill="#EDE3CB" />
      <path d="M34 68.5 l4 1 M34.5 70.2 l4 1.2 M54 69 l4.5 1.4" stroke="#DC2626" strokeWidth="1" strokeLinecap="round" />
    </g>
    {/* the ewe, fallen and horned */}
    <g>
      <ellipse cx="68" cy="71.5" rx="7" ry="1.3" fill="#8B0000" opacity="0.65" />
      <circle cx="62" cy="65" r="3" fill="#141019" stroke="#8B0000" strokeWidth="0.9" />
      <circle cx="65.6" cy="63.6" r="3.2" fill="#141019" stroke="#8B0000" strokeWidth="0.9" />
      <circle cx="69.4" cy="64.2" r="3" fill="#141019" stroke="#8B0000" strokeWidth="0.9" />
      <path d="M63.5 62.5 L62 57 M66.5 61.5 L66 56 M69.5 61.8 L70.5 56.6" stroke="#8F8578" strokeWidth="0.9" strokeLinecap="round" />
      <circle cx="75" cy="60" r="3" fill="#141019" stroke="#8B0000" strokeWidth="0.9" />
      <path d="M73.4 57.4 q-2.4 -1.8 -1.2 -4" stroke="#D4AF37" strokeWidth="0.9" fill="none" strokeLinecap="round" />
      <path d="M73.8 59 l2.4 2.4 M76.2 59 l-2.4 2.4" stroke="#DC2626" strokeWidth="0.7" />
    </g>
    {/* cracks */}
    <path d="M17.5 40 l4.5 5 -3 7" stroke="#D4AF37" strokeWidth="0.8" opacity="0.7" />
    <path d="M78.5 40 l-4.5 5 3 7" stroke="#D4AF37" strokeWidth="0.8" opacity="0.7" />
  </svg>
);

export const PentagramMark = ({ className = 'w-full h-full' }) => (
  <svg viewBox="0 0 200 200" fill="none" className={className} aria-hidden="true">
    <circle cx="100" cy="100" r="92" stroke="currentColor" strokeWidth="1" />
    <circle cx="100" cy="100" r="70" stroke="currentColor" strokeWidth="0.6" opacity="0.6" />
    <path d="M100 172 L136 62 L34 124 H166 L64 62 Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
  </svg>
);
